module.exports = __webpack_public_path__ + "img/setup_icon_clock.d75adf6f.png";